"use strict";

/**
 * Wrap current block
 * @param {Slate.State} state
 * @param {Object} opts
 * @return {Slate.State}
 */
function wrapInList(state, listType, opts) {
  return state.transform().wrapBlock(listType).wrapBlock(opts.typeItem).apply();
}

module.exports = wrapInList;


//////////////////
// WEBPACK FOOTER
// ./~/slate-edit-list/dist/wrapInList.js
// module id = 679
// module chunks = 0